import { useMemo } from 'react'

import type { SearchSchoolResponseSchoolSubscription } from '@services/SchoolService'

export const ActiveUserCell = ({
    schoolSubscriptions
}: {
    schoolSubscriptions: SearchSchoolResponseSchoolSubscription[]
}) => {
    const count = useMemo(() => {
        return schoolSubscriptions.reduce((collector: number, ss) => {
            return collector + ss._count.schoolSubscriptionSeats + ss.claim.length
        }, 0)
    }, [...schoolSubscriptions])

    return <>{count}</>
}
